export default __webpack_public_path__ + "static/media/user-auth.e7a42da1.svg";